import React from "react";
import { View, ViewStyle } from "react-native";
import { colors } from "assets/constants";

export default function Separator(props: SeparatorT) {
  const {
    cover,
    weight = 1,
    size = "100%",
    color = colors.border,
    axis = "x",
    space = 6,
    spaces,
    pos = "center",
  } = props;

  const style: ViewStyle = cover
    ? { flex: 1 }
    : {
        width: axis === "x" ? size : weight,
        height: axis === "y" ? size : weight,
        alignSelf:
          pos === "center"
            ? "center"
            : pos === "end"
            ? "flex-end"
            : "flex-start",
        backgroundColor: color,
        marginTop: spaces?.top,
        marginBottom: spaces?.bottom,
        marginLeft: spaces?.left,
        marginRight: spaces?.right,
        margin: space,
      };

  return <View style={style} />;
}
